import { useState } from 'react'

const readStored = (key: string, fallback: boolean) => {
  try {
    const stored = window.localStorage.getItem(key)
    return stored === 'true' ? true : stored === 'false' ? false : fallback
  } catch {
    return fallback
  }
}

const writeStored = (key: string, open: boolean) => {
  try {
    window.localStorage.setItem(key, String(open))
  } catch {
    // Storage blocked (private mode, quota): the state still works for this session
  }
}

/** An open/closed flag persisted in localStorage as 'true' / 'false' (the format ui-lib's Disclosure uses). */
export const useStoredOpen = (key: string, defaultOpen: boolean) => {
  const [open, setOpenState] = useState(() => readStored(key, defaultOpen))
  const setOpen = (next: boolean) => {
    setOpenState(next)
    writeStored(key, next)
  }
  return [open, setOpen] as const
}
